import React, { FC } from 'react';
import { HeadingThree } from 'hui';
import ParsingProgress from './ParsingProgressPage';
import ParseSucceeded from './ParseSuccessedPage';
import ParseFailed from './ParseFailedPage';
import { HeadingWrapper } from './style';

interface ParseAreaProps {
  parseStatus: string;
  parseFinalResult?: string;
  responseDetail?: string[];
  responseFailReason?: string;
  closeParseProgressBar?(value: string): void;
}

const ParseArea: FC<ParseAreaProps> = ({
  parseStatus,
  parseFinalResult,
  responseDetail,
  responseFailReason,
  closeParseProgressBar,
}) => (
  <>
    <HeadingWrapper>
      <HeadingThree>2. Parse file</HeadingThree>
    </HeadingWrapper>
    <div>
      {parseStatus === 'parsing' && (
        <ParsingProgress
          closeParseProgressBar={closeParseProgressBar}
          parseFinalResult={parseFinalResult}
        />
      )}
      {parseStatus === 'success' && <ParseSucceeded />}
      {parseStatus === 'fail' && (
        <ParseFailed detail={responseDetail} failReason={responseFailReason} />
      )}
    </div>
  </>
);

export default ParseArea;
